import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import Placement from 'components/Placement'
import { Wrapper, Article, ImageWrapper } from 'components/AdListItem/styled'
import styled from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'
import featuresPlugin from '@blazar-plugins/features'
import { actionCreators as classifiedActionCreators } from 'reduxBits/classified'
import AdListItem from 'components/AdListItem'
import { ListTextPlaceholder, PlaceholderWrapper } from 'utils/LoadingAnimationStyles'
import { RectShape } from 'react-placeholder/lib/placeholders'

const imageBorderRadius = { borderRadius: 2 }

export const ListPlaceholder = React.memo(({ device }) => (
  <div className="show-loading-animation">
    {Array.from(new Array(40)).map((_val, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={i}>
        <Wrapper>
          <Article>
            <ImageWrapper>
              <RectShape color="#f9f7f6" style={imageBorderRadius} />
            </ImageWrapper>
            <ListTextPlaceholder
              device={device}
              color="#f9f7f6"
              marginTop={device.is('medium') ? '75px' : '30px'}
            />
          </Article>
        </Wrapper>
      </React.Fragment>
    ))}
  </div>
))

ListPlaceholder.propTypes = {
  device: PropTypes.object.isRequired,
}

const SearchResultsWrapper = styled.div`
  padding-top: 0;
  border-bottom: 1px solid #bab9b8;
  .blocket-placement {
    border-bottom: 0.5px solid #e1e1e1;
  }
  @media ${mediaQueries.large} {
    border-bottom: 0;
  }
`

// https://docs.google.com/spreadsheets/d/1RRmaYd4LTVVQlDOat--gQhdRo9LwEs0hYrgiFNH3VRg/edit?ts=5d0b526e
const PLACEMENT_LIST_INDEX_MAP = {
  small: {
    // Location 5
    4: {
      id: 'top_device',
    },
    // Location 13
    11: {
      id: 'native_device',
      cogwheel: false,
      safeframe: false,
    },
    // Location 20
    17: {
      id: 'panorama_device_1',
    },
    // Location 24
    22: {
      id: 'native_device_2',
      cogwheel: false,
      safeframe: false,
    },
    // Location 34
    30: {
      id: 'panorama_device_2',
    },
  },
  medium: {
    // Location 12
    11: {
      id: 'placement_native',
      cogwheel: false,
      safeframe: false,
    },
    // Location 24
    22: {
      id: 'placement_native_2',
      cogwheel: false,
      safeframe: false,
    },
  },
}

const mapStateToProps = (state) => ({
  ads: state.classified.searchResults.ads,
  inventory: state.classified.searchResults.inventory,
  viewMode: state.searchParams.viewMode,
  isPremiumTooltipEnabled: featuresPlugin.selectors.isEnabled(state, 'premium-filter-tooltip'),
})

const mapDispatchToProps = (dispatch) => ({
  classifiedActions: bindActionCreators(classifiedActionCreators, dispatch),
})

export const _SearchResults = ({
  ads,
  inventory,
  classifiedActions,
  layout = 'small',
  device,
  loading,
  isPremiumTooltipEnabled,
}) => {
  const searchResultList = ads.filter(Boolean).map((ad, index) => {
    const adListItem = (
      <AdListItem
        key={ad.adId}
        ad={ad}
        onClick={() => {
          classifiedActions.adClicked({ adId: ad.adId })
        }}
        index={index}
        isPremiumTooltipEnabled={isPremiumTooltipEnabled}
      />
    )
    const placementConfig = PLACEMENT_LIST_INDEX_MAP[layout][index]
    if (placementConfig) {
      return [
        <Placement
          {...placementConfig}
          key={placementConfig.id}
          inventory={inventory}
          path="list"
        />,
        adListItem,
      ]
    }

    return adListItem
  })

  return (
    <>
      <PlaceholderWrapper>
        <ReactPlaceholder ready={!loading} customPlaceholder={<ListPlaceholder device={device} />}>
          <SearchResultsWrapper>{searchResultList}</SearchResultsWrapper>{' '}
        </ReactPlaceholder>
      </PlaceholderWrapper>
    </>
  )
}

_SearchResults.propTypes = {
  ads: PropTypes.array.isRequired,
  inventory: PropTypes.object,
  classifiedActions: PropTypes.object.isRequired,
  layout: PropTypes.string,
  device: PropTypes.shape({ is: PropTypes.func.isRequired }).isRequired,
  loading: PropTypes.bool,
  isPremiumTooltipEnabled: PropTypes.bool,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(_SearchResults),
)
